import React from "react";

import { isMetamask } from "../utils/browser-detect";

export const MMGuard = ({ children }: { children: React.ReactNode }) => {
  if (isMetamask) {
    return <>{children}</>;
  }

  return (
    <div className="flex items-center justify-center min-h-screen bg-black text-white">
      Access from MetaMask mobile app
    </div>
  );
};
